import makeHTTPRequest from '../makeHTTPRequest';

export const status = batchId =>
  makeHTTPRequest({ path: `/batch_status/${batchId}.json` });
export const createNoopBatch = () =>
  makeHTTPRequest({ path: '/api/v2/noop_batch_jobs', method: 'POST' });
